// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__chHnV","content":"styles_content__2MSeI"};